import React from 'react';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { userHasRoles } from '@plone/volto/helpers/User/User';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import rightArrowSVG from '@plone/volto/icons/right-key.svg';

const ToolbarUserMenuPlug = () => {
  const user = useSelector((state) => state.users.user);
  const canViewLogs = user?.roles
    ? userHasRoles(user, ['Manager', 'Parameter Manager'])
    : false;

  if (!canViewLogs) return null;

  const messages = defineMessages({
    scriptAuditReport: {
      id: 'Script Audit Report',
      defaultMessage: 'Script Audit Report',
    },
  });

  return (
    <Plug pluggable="toolbar-user-menu" id="govbr-audit-site">
      <li>
        <Link to="/log/audit-site">
          <FormattedMessage {...messages.scriptAuditReport} />
          <Icon name={rightArrowSVG} size="24px" />
        </Link>
      </li>
    </Plug>
  );
};

export default ToolbarUserMenuPlug;
